import { Component, OnInit, inject, input } from '@angular/core';
import { AgGridModule } from 'ag-grid-angular';
import { ColDef, ColGroupDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { FormlyService } from '../../../services/component-services/formly.service';
import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';

@Component({
  selector: 'app-report-grid',
  templateUrl: './report-grid.component.html',
  styleUrl: './report-grid.component.scss',
  imports: [BaseInlineFormComponent, AgGridModule],
})
export class ReportGridComponent implements OnInit {
  private readonly formlyService = inject(FormlyService);

  public readonly header = input<string>();
  public readonly gridCssClass = input<string>();
  public readonly columnDefs = input<(ColDef | ColGroupDef)[]>([]);
  public readonly rowData = input<any[]>();
  public readonly fields = input<FormlyFieldConfig[]>([]);
  public readonly labelsVertical = input(false);

  protected gridOptions: GridOptions;
  public model: any = { preview: false };

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;

  ngOnInit() {
    this.fields().push(
      ...[
        this.formlyService.button('Print', () => this.print(), {
          iconClass: 'fa fa-print',
        }),
        this.formlyService.button(
          'Preview',
          () => this.togglePreview(),
          {
            btnClass: 'secondary',
          },
          undefined,
          {
            'props.iconClass': (field: FormlyFieldConfig) => (field.model?.preview ? 'fa fa-eye-slash' : 'fa fa-eye'),
          },
        ),
        this.formlyService.exportButtonNoGridComponent(() => this.export()),
      ],
    );

    this.gridOptions = {
      columnDefs: this.columnDefs(),
      defaultColDef: {
        filter: true,
        resizable: true,
        sortable: true,
      },
    };
  }

  gridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  export() {
    this.gridApi.exportDataAsCsv({ fileName: this.header() });
  }

  print() {
    window.print();
  }

  togglePreview() {
    this.model.preview = !this.model.preview;
  }

  rowDataUpdated() {
    this.gridColumnApi?.autoSizeAllColumns();
  }
}
